import { render, staticRenderFns } from "./m-restricted-menu-list-item.vue?vue&type=template&id=1466de56&scoped=true&"
import script from "./m-restricted-menu-list-item.vue?vue&type=script&lang=js&"
export * from "./m-restricted-menu-list-item.vue?vue&type=script&lang=js&"
import style0 from "./m-restricted-menu-list-item.vue?vue&type=style&index=0&id=1466de56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1466de56",
  null
  
)

export default component.exports